import { render, staticRenderFns } from "./default_old.vue?vue&type=template&id=328340ce&scoped=true"
import script from "./default_old.vue?vue&type=script&lang=js"
export * from "./default_old.vue?vue&type=script&lang=js"
import style0 from "./default_old.vue?vue&type=style&index=0&id=328340ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328340ce",
  null
  
)

export default component.exports